<template>
    <img v-if="image" :src="image" class="h-6 w-6 rounded-full object-cover" />
    <div
        v-else
        class="pt-1 text-xs rounded-full bg-gray-300 font-normal h-6 w-6 text-center items-center text-gray-700"
    >
        {{ fullName ? getInitials(fullName) : fullName.charAt(0).toUpperCase() }}
    </div>
</template>
<script setup lang="ts">
import { getInitials } from "@/shared/utils/helpers"

interface Props {
    image?: string
    fullName?: string
}

defineProps<Props>()
</script>
